import { createSlice } from "@reduxjs/toolkit";
import { registerCartExtraReducers } from "./extraReducers";
import { initialState } from "./initialState";
import { cartReducers } from "./reducers";

export const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: cartReducers,
  extraReducers: registerCartExtraReducers,
});

export const {
  setProductionCartItems,
  setRemainsCartItems,
  setTotalProdPrice,
  setSelectedProdIds,
  setSelectedRemainsIds,
  setSelectedAllRows,
  setFrom,
  changeAllFilialsId,
  changeFilialsIdToShow,
  changeDealersIdToShow,
  changeAllDealersId,
  setCartLoader,
  clearAllFilialsIds,
  setSelectedAllDealerRows,
  setCanCreateOrder,
  setDeleteMode,
  setProductionFilters,
  setRemainsFilters,
  setSelectedProductionFilters,
  setSelectedRemainsFilters,
  clearProductionFilters,
  clearRemainsFilters,
  clearCartFilters,
  setProductionOrder,
  setRemainsOrder,
  setProductionPageSize,
  setRemainsPageSize,
  setProductionPageNumber,
  setRemainsPageNumber,
  setProductionDefaultOrder,
  setRemainsDefaultOrder,
  setDealerRemainsPageSize,
  setDealerRemainsPageNumber,
  setDealerRemainsSort,
  toggleDealerRemainsCollapsed,
  setCollapsedDealerRemainsIds,
  toggleDealerRemainsBasketIds,
} = cartSlice.actions;
